<template>
  <page-view :title="true">
    <a-card>
      <a-descriptions :title="houseInfo.houseName" :column="2">
        <a-descriptions-item label="房间类型">{{
          houseInfo.rentTypeName
        }}</a-descriptions-item>
        <a-descriptions-item label="房间号">{{
          paramData.no
        }}</a-descriptions-item>
        <a-descriptions-item label="付款周期">{{
          paramData.payCycle
        }}</a-descriptions-item>
        <a-descriptions-item label="付款方式">
          <a-select
            style="width: 150px"
            v-model="paramData.payWay"
            @change="handleChange"
          >
            <a-select-option
              v-for="item in payWayList"
              :value="item.dictCode"
              :key="item.dictCode"
              >{{ item.dictName }}</a-select-option
            >
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item label="月租金"
          ><a-input v-model="paramData.monthRent" suffix="元"></a-input
        ></a-descriptions-item>
        <a-descriptions-item label="押金"
          ><a-input v-model="paramData.deposit" suffix="元"></a-input
        ></a-descriptions-item>
        <a-descriptions-item label="租约开始日期"
          ><a-date-picker
            @change="dateChange"
            :format="dateFormat"
            v-model="paramData.startTime"
        /></a-descriptions-item>
        <a-descriptions-item label="下次交租日期">{{
          paramData.nextTime
        }}</a-descriptions-item>
        <a-descriptions-item label="租约结束日期"
          ><a-date-picker :format="dateFormat" v-model="paramData.finishTime"
        /></a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <a-descriptions title="租客信息"></a-descriptions>
      <a-form-model
        ref="ruleForm"
        :rules="userSimpleRule"
        :model="userSimpleData"
        :labelCol="{ span: 4 }"
        :wrapperCol="{ span: 20 }"
        class="form"
      >
        <a-row :gutter="24">
          <a-col :sm="24" :md="12" :xl="12">
            <a-form-model-item label="姓名" prop="realName"
              ><a-input
                placeholder="请输入姓名"
                v-model="userSimpleData.realName"
            /></a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="12">
            <a-form-model-item label="出租方式" prop="sex">
              <a-radio-group v-model="userSimpleData.sex">
                <a-radio value="男">男</a-radio>
                <a-radio value="女">女</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="12">
            <a-form-model-item label="手机号" prop="mobile"
              ><a-input
                placeholder="请输入手机号"
                v-model="userSimpleData.mobile"
            /></a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="12">
            <a-form-model-item label="身份证号" prop="idcard"
              ><a-input
                placeholder="请输入身份证号"
                v-model="userSimpleData.idcard"
            /></a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item
              label="补充条款"
              :labelCol="{ span: 2 }"
              :wrapperCol="{ span: 22 }"
            >
              <a-input
                style="width: 100%;"
                v-model="userSimpleData.terms"
                :rows="4"
                type="textarea"
                :maxLength="200"
                placeholder="请输入补充条款"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div v-if="verifyParam.visible">
        <a-descriptions title="验证租客身份"></a-descriptions>
        <a-form-model
        ref="verifyForm"
        :rules="verifyParamRule"
        :model="verifyParam"
        :labelCol="{ span: 4 }"
        :wrapperCol="{ span: 20 }"
        class="form"
      >
        <a-row :gutter="24">
          <a-col :sm="24" :md="12" :xl="12">
            <a-form-model-item label="身份校验码" prop="vcode"
              ><a-input
                placeholder="填入租客手机接收的身份校验码"
                v-model="verifyParam.vcode"
            /></a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="verifyParam.showAgreement">
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item
              label=""
              :labelCol="{ span: 2 }"
              :wrapperCol="{ span: 22 }"
            >
              <p class="tip-text">提示：需要租客打开以下链接，进行CA电子认证服务协议阅读，确认同意后，方能进行后续租房合同流转</p>
              <a-input
                style="width: 100%;"
                v-model="verifyParam.agreementUrl"
                :rows="4"
                type="textarea"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      </div>
      <div class="operation">
        <a-button @click="back" class="back">返回</a-button>
        <a-button type="primary" class="opt" v-if="!verifyParam.visible && !verifyParam.pass" :loading="verifyParam.checking" @click="createLeasePreCheck">获取租客身份校验码</a-button>
        <a-button type="primary" class="opt" v-if="verifyParam.visible && !verifyParam.pass" :loading="verifyParam.verifying" @click="submitVerify">验证租客身份</a-button>
        <a-popconfirm
          title="确认创建租约吗？"
          @confirm="ok"
          okText="确认"
          cancelText="取消"
          v-if="verifyParam.pass"
        >
          <a-button type="primary" :loading="confirmLoading">创建租约</a-button>
        </a-popconfirm>
      </div>
      <div class="ps-form-style-desc">
        <h3>特别说明</h3>
        <p>1、确保租客信息填写正确。</p>
        <p>2、创建租约过程存在多个认证环节，请耐心等待。</p>
      </div>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
import moment from "moment";
import cloneDeep from "lodash.clonedeep";
import { monthFormat, formatting, mobile, idcard } from "@/utils/util.js";
export default {
  components: {
    PageView
  },
  name: "CreateLeaseInfo",
  data() {
    let handleMobile = (rule, value, callback) => {
      if (!mobile(value)) {
        callback("请输入正确的手机号");
      }
      callback();
    };
    let handleIdcard = (rule, value, callback) => {
      if (!idcard(value)) {
        callback("请输入正确的身份证号");
      }
      callback();
    };
    return {
      userInfo: {},
      houseNo: "",
      keeperNo: "",
      queryParam: null,
      houseInfo: {},
      dateFormat: "YYYY-MM-DD",
      paramData: {
        payCycle: "", //付款周期
        deposit: 0, //押金
        rent: 0, //月租金
        rentStr: "",
        month: 0, //付几个月租金
        address: "",
        startTime: "",
        finishTime: "",
        nextTime: "",
        payWay: "",
        monthRent: 0
      },
      payWayList: [], //付款方式
      verifyParam: {
        checking: false,
        visible: false,
        verifying: false,
        pass: false,
        showAgreement: false,
        vcode: '',
        personalIdentity3Key: '',
        agreementUrl: '',
        userNo: ''
      },
      verifyParamRule: {
        vcode: [{ required: true, message: "请输入身份校验码" }]
      },
      userSimpleData: {
        realName: "",
        sex: "男",
        mobile: "",
        idcard: "",
        terms: ""
      },
      userSimpleRule: {
        realName: [{ required: true, message: "请输入姓名" }],
        sex: [{ required: true, message: "请选择性别" }],
        mobile: [
          { required: true, message: "请输入手机号" },
          { validator: handleMobile, trigger: "change" }
        ],
        idcard: [
          { required: true, message: "请输入身份证号" },
          { validator: handleIdcard, trigger: "change" }
        ]
      },
      confirmLoading: false
    };
  },
  created() {
    this.verifyParam.pass = false;
    this.userInfo = this.$store.getters.userInfo;
    let query = this.$route.query;
    if (query.houseNo) {
      this.paramData.payWay = query.payWay;
      this.houseNo = query.houseNo;
      //开始-结束时间
      this.paramData.startTime = moment(new Date(), this.dateFormat);
      this.paramData.finishTime = moment(new Date(), this.dateFormat);
      this.getHouseInfo();
      this.getBaseInfo();
    }
    if (query.keeperNo) {
      this.keeperNo = query.keeperNo;
    }
    if (query.param) {
      this.queryParam = query.param;
    }
  },

  methods: {
    back() {
      this.$router.push({
        name: "HouseList",
        query: { param: this.queryParam }
      });
    },
    async getBaseInfo() {
      this.$http.roomBksApi.findHouseKindData().then(res => {
        if (res.result == 0) {
          this.payWayList = res.resultObject.payWayList;
          //计算租金
          this.handleChange(this.paramData.payWay);
        }
      });
    },
    dateChange(value) {
      this.computeNextTime(value);
    },
    computeNextTime(value) {
      if (value) {
        let m = 0;
        if (this.paramData.month == 1) {
          m = 1;
        } else {
          m = this.paramData.month - 1;
        }
        let month = value.month() + parseInt(m);
        let current = cloneDeep(value);
        let currentFinish = cloneDeep(value);
        this.paramData.nextTime = current.month(month).format(this.dateFormat);
        if (this.houseInfo.shortLease) {
          this.paramData.finishTime = currentFinish
            .add(this.houseInfo.shortLease, "M")
            .subtract(1, "days");
        }
      }
    },
    handleChange(selectItem) {
      let args = this.getPayWay(selectItem);
      let arr = args.split(",");
      if (arr && arr.length > 1) {
        let month = arr[1];
        this.paramData.month = month;
        let multiple = arr[0];
        this.paramData.deposit =
          parseInt(multiple) * parseInt(this.paramData.monthRent);
        this.paramData.payCycle = monthFormat(month);
        this.computeNextTime(this.paramData.startTime);
      }
    },
    getPayWay(value) {
      let args = "";
      for (let item of this.payWayList) {
        if (item.dictCode == value) {
          this.paramData.payWayName = item.dictName;
          args = item.args;
          break;
        }
      }
      return args;
    },
    async getHouseInfo() {
      this.$http.roomBksApi
        .findHouseInfoByHouseNo({ houseNo: this.houseNo })
        .then(res => {
          this.houseInfo = res.resultObject;
          this.paramData.keeperUserNo = this.keeperNo;
          this.paramData.houseName = this.houseInfo.houseName;
          this.paramData.rentTypeName = this.houseInfo.rentTypeName;
          let address = ""; //地址
          let no = ""; //房间号(楼号+单元号+门牌号+房号)
          if (this.houseInfo.buildingNo) {
            no += this.houseInfo.buildingNo;
            if (this.houseInfo.buildingNo.indexOf("楼") < 0) {
              address += this.houseInfo.buildingNo + "楼";
            } else {
              address += this.houseInfo.buildingNo;
            }
          }
          if (this.houseInfo.unitNo) {
            no += "-" + this.houseInfo.unitNo;
            if (this.houseInfo.unitNo.indexOf("单元") < 0) {
              address += this.houseInfo.unitNo + "单元";
            } else {
              address += this.houseInfo.unitNo;
            }
          }
          if (this.houseInfo.houseNum) {
            no += "-" + this.houseInfo.houseNum;
            address += "-" + this.houseInfo.houseNum;
          }
          if (this.houseInfo.roomNum) {
            no += "-" + this.houseInfo.roomNum;
            address += "-" + this.houseInfo.roomNum;
          }
          this.paramData.address = address;
          this.paramData.no = no;
          this.paramData.rent = this.houseInfo.rent;
          this.paramData.monthRent = this.houseInfo.rent;
          this.paramData.payWay = this.houseInfo.payWay;
          this.paramData.payWayName = this.houseInfo.payWayName;
          this.paramData.payWayArgs = this.houseInfo.payWayArgs;
          this.paramData.rentType = this.houseInfo.rentType;
          this.paramData.rentTypeName = this.houseInfo.rentTypeName;
          this.paramData.houseNo = this.houseInfo.houseNo;
          this.paramData.shortLease = this.houseInfo.shortLease;
          this.paramData.merchantNo = this.houseInfo.merchantNo;
          this.paramData.finishTime = moment()
            .add(this.houseInfo.shortLease, "M")
            .subtract(1, "days");
        });
    },
    createLeasePreCheck(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = {};
          let houseUserLease = Object.assign({}, this.paramData);
          houseUserLease.sta = "R";
          let start = this.paramData.startTime.format(this.dateFormat);
          let end = this.paramData.finishTime.format(this.dateFormat);
          houseUserLease.startTime = start + " 00:00:00";
          houseUserLease.finishTime = end + " 23:59:59";
          houseUserLease.nextTime = this.paramData.nextTime + " 23:59:59";
          houseUserLease.checkSta = this.userInfo.userType == "2" ? "C" : "S";
          houseUserLease.businessType = "sure";
          houseUserLease.terms = this.userSimpleData.terms;
          param.userSimple = this.userSimpleData;
          delete houseUserLease.payCycle;
          delete param.userSimple.terms;
          param.houseUserLease = houseUserLease;
          param.type = "create";
          if (!this.verifyParam.checking) {
            this.verifyParam.checking = true;
          }
          this.$http.roomBksApi.merchantCreateLeasePreCheck(param).then(res => {
            this.verifyParam.checking = false;
            if (res.result == 0) {
              if(res.resultObject.code == 100){
                this.verifyParam.visible = true;
                this.verifyParam.agreementUrl = res.resultObject.ssqAgreementUrl;
                this.verifyParam.personalIdentity3Key = res.resultObject.personalIdentity3Key;
                this.verifyParam.userNo = res.resultObject.userNo;
              } else {
                this.verifyParam.visible = false;
                this.verifyParam.pass = true;
              }
            }
          });
        }
      });
    },
    submitVerify(){
      this.verifyParam.showAgreement = false;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let {vcode, personalIdentity3Key, userNo, authType} = this.verifyParam;
          let param = {vcode, personalIdentity3Key, userNo};
          param.authType = "mobile";
          param.userType = "personal";
          if (!this.verifyParam.verifying) {
            this.verifyParam.verifying = true;
          }
          this.$http.roomBksApi.personalAuthVcodeVerify(param).then(res => {
            this.verifyParam.verifying = false;
            if(res.result == 0){
              this.verifyParam.pass = true;
              this.verifyParam.showAgreement = true;
            }
          });
        }
      });
    },
    ok() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = {};
          let houseUserLease = Object.assign({}, this.paramData);
          houseUserLease.sta = "R";
          let start = this.paramData.startTime.format(this.dateFormat);
          let end = this.paramData.finishTime.format(this.dateFormat);
          houseUserLease.startTime = start + " 00:00:00";
          houseUserLease.finishTime = end + " 23:59:59";
          houseUserLease.nextTime = this.paramData.nextTime + " 23:59:59";
          houseUserLease.checkSta = this.userInfo.userType == "2" ? "C" : "S";
          houseUserLease.businessType = "sure";
          houseUserLease.terms = this.userSimpleData.terms;
          param.userSimple = this.userSimpleData;
          delete houseUserLease.payCycle;
          delete param.userSimple.terms;
          param.houseUserLease = houseUserLease;
          param.type = "create";
          if (!this.confirmLoading) {
            this.confirmLoading = true;
          }
          this.$http.roomBksApi.merchantCreateLease(param).then(res => {
            this.confirmLoading = false;
            if (res.result == 0) {
              this.back();
              this.$message.success(res.msg);
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.operation {
  text-align: center;
  margin: 20px auto 5px;
  .back {
    margin: 0 10px;
  }
  .opt {
    margin-right: 10px;
  }
}
.tip-text {
  font-weight: bold;
}
.ps-form-style-desc {
  h3 {
    margin: 0 0 12px;
    font-size: 16px;
    line-height: 32px;
    color: red;
  }

  p {
    margin-top: 0;
    margin-bottom: 12px;
    line-height: 22px;
    color: red;
  }
}
</style>
